import type { TypedAction } from '../types';

import {
  GET_LMIS_ERROR,
  GET_LMIS_SUCCESS,
  PageKeys,
  RESET_JDP_LMIS,
  type LmisState,
} from './types';

const initialItemState = {
  content: '',
  lmisSnippet: undefined,
};

export const initialState = {
  [PageKeys.SRP]: initialItemState,
  [PageKeys.JDP]: initialItemState,
};

export default function reducer(
  state: LmisState = initialState,
  action: TypedAction,
): LmisState {
  switch (action.type) {
    case RESET_JDP_LMIS: {
      return {
        ...state,
        [PageKeys.JDP]: initialItemState,
      };
    }
    case GET_LMIS_SUCCESS: {
      const { key } = action.payload;
      return {
        ...state,
        [key]: action.payload,
      };
    }

    case GET_LMIS_ERROR: {
      const { key } = action.payload;
      return {
        ...state,
        [key]: initialItemState,
      };
    }

    default:
      return state;
  }
}
